const actions = {
    SHOEBOX_TRANSACTION_SET: 'SHOEBOX_TRANSACTION_SET',
    SHOEBOX_TRANSACTION_SET_TYPE: 'SHOEBOX_TRANSACTION_SET_TYPE',
    SHOEBOX_TRANSACTION_SET_PAYMENT_MODE: 'SHOEBOX_TRANSACTION_SET_PAYMENT_MODE',
    SHOEBOX_TRANSACTION_SET_CONTACT_NAME: 'SHOEBOX_TRANSACTION_SET_CONTACT_NAME',
    SHOEBOX_TRANSACTION_SET_CONTACT2_NAME: 'SHOEBOX_TRANSACTION_SET_CONTACT2_NAME',
    SHOEBOX_TRANSACTION_SET_DATE: 'SHOEBOX_TRANSACTION_SET_DATE',
    SHOEBOX_TRANSACTION_SET_CURRENCY_CODE: 'SHOEBOX_TRANSACTION_SET_CURRENCY_CODE',
    SHOEBOX_TRANSACTION_SET_EXCHANGE_RATE: 'SHOEBOX_TRANSACTION_SET_EXCHANGE_RATE',
    SHOEBOX_TRANSACTION_SET_TAX_MODE: 'SHOEBOX_TRANSACTION_SET_TAX_MODE',
    SHOEBOX_TRANSACTION_SET_ITEM_MODE: 'SHOEBOX_TRANSACTION_SET_ITEM_MODE',
    SHOEBOX_TRANSACTION_ADD_ITEM: 'SHOEBOX_TRANSACTION_ADD_ITEM',
    SHOEBOX_TRANSACTION_SET_ITEM: 'SHOEBOX_TRANSACTION_SET_ITEM',
    SHOEBOX_TRANSACTION_SET_ITEMS: 'SHOEBOX_TRANSACTION_SET_ITEMS',
    SHOEBOX_TRANSACTION_REMOVE_ITEM: 'SHOEBOX_TRANSACTION_REMOVE_ITEM',
    SHOEBOX_TRANSACTION_SET_ITEM_INDEX: 'SHOEBOX_TRANSACTION_SET_ITEM_INDEX',
    SHOEBOX_TRANSACTION_CREATE_REQUEST: 'SHOEBOX_TRANSACTION_CREATE_REQUEST',
    SHOEBOX_TRANSACTION_CREATE_SUCCESS: 'SHOEBOX_TRANSACTION_CREATE_SUCCESS',
    SHOEBOX_TRANSACTION_CREATE_ERROR: 'SHOEBOX_TRANSACTION_CREATE_ERROR',
    SHOEBOX_TRANSACTION_RESET: 'SHOEBOX_TRANSACTION_RESET',

    setTransaction: (transaction, reset = false) => ({
        type: actions.SHOEBOX_TRANSACTION_SET,
        transaction,
        reset,
    }),
    setType: typeString => ({
        type: actions.SHOEBOX_TRANSACTION_SET_TYPE,
        typeString,
    }),
    setPaymentMode: paymentMode => ({
        type: actions.SHOEBOX_TRANSACTION_SET_PAYMENT_MODE,
        paymentMode,
    }),
    setContactName: contactName => ({
        type: actions.SHOEBOX_TRANSACTION_SET_CONTACT_NAME,
        contactName,
    }),
    setContact2Name: contact2Name => ({
        type: actions.SHOEBOX_TRANSACTION_SET_CONTACT2_NAME,
        contact2Name,
    }),
    setDate: date => ({
        type: actions.SHOEBOX_TRANSACTION_SET_DATE,
        date,
    }),
    setCurrencyCode: currencyCode => ({
        type: actions.SHOEBOX_TRANSACTION_SET_CURRENCY_CODE,
        currencyCode,
    }),
    setExchangeRate: exchangeRate => ({
        type: actions.SHOEBOX_TRANSACTION_SET_EXCHANGE_RATE,
        exchangeRate,
    }),
    setTaxMode: taxMode => ({
        type: actions.SHOEBOX_TRANSACTION_SET_TAX_MODE,
        taxMode,
    }),
    setItemMode: itemMode => ({
        type: actions.SHOEBOX_TRANSACTION_SET_ITEM_MODE,
        itemMode,
    }),
    addItem: item => ({
        type: actions.SHOEBOX_TRANSACTION_ADD_ITEM,
        item,
    }),
    setItem: item => ({
        type: actions.SHOEBOX_TRANSACTION_SET_ITEM,
        item,
    }),
    setItems: items => ({
        type: actions.SHOEBOX_TRANSACTION_SET_ITEMS,
        items,
    }),
    removeItem: line => ({
        type: actions.SHOEBOX_TRANSACTION_REMOVE_ITEM,
        line,
    }),
    setItemIndex: line => ({
        type: actions.SHOEBOX_TRANSACTION_SET_ITEM_INDEX,
        line,
    }),
    createTransaction: request => ({
        type: actions.SHOEBOX_TRANSACTION_CREATE_REQUEST,
        request,
    }),
    reset: () => ({
        type: actions.SHOEBOX_TRANSACTION_RESET,
    }),
};
export default actions;
